// extracted by mini-css-extract-plugin
export default {"FacetHelp":"xp_a bhg_jh bhg_sy","FacetHelp__paragraph":"xp_b bhg_vr bhg_xe","FacetHelp__youtube":"xp_c"};